// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    apiUrl: 'https://disease-api-pp.kennedysiq.com/api/v1/',
    quantumApiUrl: 'https://quantumdis-pp.kennedysiq.com/v4.1/',
    kcg_config: '/assets/kcg-preprod.json',
    KcgClientID: 'Disease-Tools',
    KcgIssuer: 'https://kcg.kiqstaging.com',
    KcgScopes: 'openid email profile KcgIdpArmApi DiseaseApis KcgApis',
    KcgApiUrl: 'https://kcg-arm-api.kiqstaging.com/v1'
  };
  
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
  